import { clsx } from 'clsx';
import { HOME_BOOKING_FIELD } from './style';
import { IJxtHomeBookingSelect } from './types';

/** A choice among a list, on one line, as the booking modals' fields (an option's value, "Répéter"…). */
const JxtHomeBookingSelect = ({ label, value, options, onChange, placeholder, isInvalid }: IJxtHomeBookingSelect) => (
  <select
    aria-label={label}
    value={value}
    onChange={(event) => onChange(event.target.value)}
    className={clsx(HOME_BOOKING_FIELD, 'form-select', isInvalid && 'border-red-100')}
  >
    {placeholder !== undefined && <option value="">{placeholder}</option>}
    {options.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>
);

export default JxtHomeBookingSelect;
